// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_1sYL4CT9uq","logo":"_2KSu315PwN"};